// This file is auto-generated by @hey-api/openapi-ts

import type {
  Client,
  ClientMeta,
  Options as Options2,
  RequestResult,
  TDataShape,
} from './client';
import { client } from './client.gen';
import type {
  InstructionGetSectionListData,
  InstructionGetSectionListErrors,
  InstructionGetSectionListResponses,
  LegalGetDocumentData,
  LegalGetDocumentErrors,
  LegalGetDocumentResponses,
  PremiumGetSubscriptionInvoiceData,
  PremiumGetSubscriptionInvoiceErrors,
  PremiumGetSubscriptionInvoiceListData,
  PremiumGetSubscriptionInvoiceListErrors,
  PremiumGetSubscriptionInvoiceListResponses,
  PremiumGetSubscriptionInvoiceResponses,
  PremiumGetSubscriptionPriceCheckoutData,
  PremiumGetSubscriptionPriceCheckoutErrors,
  PremiumGetSubscriptionPriceCheckoutResponses,
  PremiumGetSubscriptionPriceData,
  PremiumGetSubscriptionPriceErrors,
  PremiumGetSubscriptionPriceListData,
  PremiumGetSubscriptionPriceListErrors,
  PremiumGetSubscriptionPriceListResponses,
  PremiumGetSubscriptionPriceResponses,
  TelegramBotsCreateApiRequestData,
  TelegramBotsCreateApiRequestErrors,
  TelegramBotsCreateApiRequestResponses,
  TelegramBotsCreateBackgroundTaskData,
  TelegramBotsCreateBackgroundTaskErrors,
  TelegramBotsCreateBackgroundTaskResponses,
  TelegramBotsCreateConditionData,
  TelegramBotsCreateConditionErrors,
  TelegramBotsCreateConditionResponses,
  TelegramBotsCreateConnectionData,
  TelegramBotsCreateConnectionErrors,
  TelegramBotsCreateConnectionResponses,
  TelegramBotsCreateDatabaseOperationData,
  TelegramBotsCreateDatabaseOperationErrors,
  TelegramBotsCreateDatabaseOperationResponses,
  TelegramBotsCreateDatabaseRecordData,
  TelegramBotsCreateDatabaseRecordErrors,
  TelegramBotsCreateDatabaseRecordResponses,
  TelegramBotsCreateDiagramRandomizerData,
  TelegramBotsCreateDiagramRandomizerErrors,
  TelegramBotsCreateDiagramRandomizerResponses,
  TelegramBotsCreateDiagramTimerData,
  TelegramBotsCreateDiagramTimerErrors,
  TelegramBotsCreateDiagramTimerResponses,
  TelegramBotsCreateDiagramTriggerData,
  TelegramBotsCreateDiagramTriggerErrors,
  TelegramBotsCreateDiagramTriggerResponses,
  TelegramBotsCreateInvoiceData,
  TelegramBotsCreateInvoiceErrors,
  TelegramBotsCreateInvoiceResponses,
  TelegramBotsCreateMessageData,
  TelegramBotsCreateMessageErrors,
  TelegramBotsCreateMessageResponses,
  TelegramBotsCreateRandomizerData,
  TelegramBotsCreateRandomizerErrors,
  TelegramBotsCreateRandomizerResponses,
  TelegramBotsCreateTelegramBotData,
  TelegramBotsCreateTelegramBotErrors,
  TelegramBotsCreateTelegramBotResponses,
  TelegramBotsCreateTemporaryVariableData,
  TelegramBotsCreateTemporaryVariableErrors,
  TelegramBotsCreateTemporaryVariableResponses,
  TelegramBotsCreateTimerData,
  TelegramBotsCreateTimerErrors,
  TelegramBotsCreateTimerResponses,
  TelegramBotsCreateTriggerData,
  TelegramBotsCreateTriggerErrors,
  TelegramBotsCreateTriggerResponses,
  TelegramBotsCreateVariableData,
  TelegramBotsCreateVariableErrors,
  TelegramBotsCreateVariableResponses,
  TelegramBotsDeleteApiRequestData,
  TelegramBotsDeleteApiRequestErrors,
  TelegramBotsDeleteApiRequestResponses,
  TelegramBotsDeleteBackgroundTaskData,
  TelegramBotsDeleteBackgroundTaskErrors,
  TelegramBotsDeleteBackgroundTaskResponses,
  TelegramBotsDeleteChatData,
  TelegramBotsDeleteChatErrors,
  TelegramBotsDeleteChatResponses,
  TelegramBotsDeleteConditionData,
  TelegramBotsDeleteConditionErrors,
  TelegramBotsDeleteConditionResponses,
  TelegramBotsDeleteConnectionData,
  TelegramBotsDeleteConnectionErrors,
  TelegramBotsDeleteConnectionResponses,
  TelegramBotsDeleteDatabaseOperationData,
  TelegramBotsDeleteDatabaseOperationErrors,
  TelegramBotsDeleteDatabaseOperationResponses,
  TelegramBotsDeleteDatabaseRecordData,
  TelegramBotsDeleteDatabaseRecordErrors,
  TelegramBotsDeleteDatabaseRecordResponses,
  TelegramBotsDeleteDiagramRandomizerData,
  TelegramBotsDeleteDiagramRandomizerErrors,
  TelegramBotsDeleteDiagramRandomizerResponses,
  TelegramBotsDeleteDiagramTimerData,
  TelegramBotsDeleteDiagramTimerErrors,
  TelegramBotsDeleteDiagramTimerResponses,
  TelegramBotsDeleteDiagramTriggerData,
  TelegramBotsDeleteDiagramTriggerErrors,
  TelegramBotsDeleteDiagramTriggerResponses,
  TelegramBotsDeleteInvoiceData,
  TelegramBotsDeleteInvoiceErrors,
  TelegramBotsDeleteInvoiceResponses,
  TelegramBotsDeleteMessageData,
  TelegramBotsDeleteMessageErrors,
  TelegramBotsDeleteMessageResponses,
  TelegramBotsDeleteRandomizerData,
  TelegramBotsDeleteRandomizerErrors,
  TelegramBotsDeleteRandomizerResponses,
  TelegramBotsDeleteTelegramBotData,
  TelegramBotsDeleteTelegramBotErrors,
  TelegramBotsDeleteTelegramBotResponses,
  TelegramBotsDeleteTemporaryVariableData,
  TelegramBotsDeleteTemporaryVariableErrors,
  TelegramBotsDeleteTemporaryVariableResponses,
  TelegramBotsDeleteTimerData,
  TelegramBotsDeleteTimerErrors,
  TelegramBotsDeleteTimerResponses,
  TelegramBotsDeleteTriggerData,
  TelegramBotsDeleteTriggerErrors,
  TelegramBotsDeleteTriggerResponses,
  TelegramBotsDeleteUserData,
  TelegramBotsDeleteUserErrors,
  TelegramBotsDeleteUserResponses,
  TelegramBotsDeleteVariableData,
  TelegramBotsDeleteVariableErrors,
  TelegramBotsDeleteVariableResponses,
  TelegramBotsGetApiRequestData,
  TelegramBotsGetApiRequestErrors,
  TelegramBotsGetApiRequestListData,
  TelegramBotsGetApiRequestListErrors,
  TelegramBotsGetApiRequestListResponses,
  TelegramBotsGetApiRequestResponses,
  TelegramBotsGetBackgroundTaskData,
  TelegramBotsGetBackgroundTaskErrors,
  TelegramBotsGetBackgroundTaskListData,
  TelegramBotsGetBackgroundTaskListErrors,
  TelegramBotsGetBackgroundTaskListResponses,
  TelegramBotsGetBackgroundTaskResponses,
  TelegramBotsGetChatData,
  TelegramBotsGetChatErrors,
  TelegramBotsGetChatListData,
  TelegramBotsGetChatListErrors,
  TelegramBotsGetChatListResponses,
  TelegramBotsGetChatResponses,
  TelegramBotsGetConditionData,
  TelegramBotsGetConditionErrors,
  TelegramBotsGetConditionListData,
  TelegramBotsGetConditionListErrors,
  TelegramBotsGetConditionListResponses,
  TelegramBotsGetConditionResponses,
  TelegramBotsGetDatabaseOperationData,
  TelegramBotsGetDatabaseOperationErrors,
  TelegramBotsGetDatabaseOperationListData,
  TelegramBotsGetDatabaseOperationListErrors,
  TelegramBotsGetDatabaseOperationListResponses,
  TelegramBotsGetDatabaseOperationResponses,
  TelegramBotsGetDatabaseRecordData,
  TelegramBotsGetDatabaseRecordErrors,
  TelegramBotsGetDatabaseRecordListData,
  TelegramBotsGetDatabaseRecordListErrors,
  TelegramBotsGetDatabaseRecordListResponses,
  TelegramBotsGetDatabaseRecordResponses,
  TelegramBotsGetDiagramApiRequestData,
  TelegramBotsGetDiagramApiRequestErrors,
  TelegramBotsGetDiagramApiRequestListData,
  TelegramBotsGetDiagramApiRequestListErrors,
  TelegramBotsGetDiagramApiRequestListResponses,
  TelegramBotsGetDiagramApiRequestResponses,
  TelegramBotsGetDiagramBackgroundTaskData,
  TelegramBotsGetDiagramBackgroundTaskErrors,
  TelegramBotsGetDiagramBackgroundTaskListData,
  TelegramBotsGetDiagramBackgroundTaskListErrors,
  TelegramBotsGetDiagramBackgroundTaskListResponses,
  TelegramBotsGetDiagramBackgroundTaskResponses,
  TelegramBotsGetDiagramConditionData,
  TelegramBotsGetDiagramConditionErrors,
  TelegramBotsGetDiagramConditionListData,
  TelegramBotsGetDiagramConditionListErrors,
  TelegramBotsGetDiagramConditionListResponses,
  TelegramBotsGetDiagramConditionResponses,
  TelegramBotsGetDiagramDatabaseOperationData,
  TelegramBotsGetDiagramDatabaseOperationErrors,
  TelegramBotsGetDiagramDatabaseOperationListData,
  TelegramBotsGetDiagramDatabaseOperationListErrors,
  TelegramBotsGetDiagramDatabaseOperationListResponses,
  TelegramBotsGetDiagramDatabaseOperationResponses,
  TelegramBotsGetDiagramInvoiceData,
  TelegramBotsGetDiagramInvoiceErrors,
  TelegramBotsGetDiagramInvoiceListData,
  TelegramBotsGetDiagramInvoiceListErrors,
  TelegramBotsGetDiagramInvoiceListResponses,
  TelegramBotsGetDiagramInvoiceResponses,
  TelegramBotsGetDiagramMessageData,
  TelegramBotsGetDiagramMessageErrors,
  TelegramBotsGetDiagramMessageListData,
  TelegramBotsGetDiagramMessageListErrors,
  TelegramBotsGetDiagramMessageListResponses,
  TelegramBotsGetDiagramMessageResponses,
  TelegramBotsGetDiagramRandomizerData,
  TelegramBotsGetDiagramRandomizerErrors,
  TelegramBotsGetDiagramRandomizerListData,
  TelegramBotsGetDiagramRandomizerListErrors,
  TelegramBotsGetDiagramRandomizerListResponses,
  TelegramBotsGetDiagramRandomizerResponses,
  TelegramBotsGetDiagramTemporaryVariableData,
  TelegramBotsGetDiagramTemporaryVariableErrors,
  TelegramBotsGetDiagramTemporaryVariableListData,
  TelegramBotsGetDiagramTemporaryVariableListErrors,
  TelegramBotsGetDiagramTemporaryVariableListResponses,
  TelegramBotsGetDiagramTemporaryVariableResponses,
  TelegramBotsGetDiagramTimerData,
  TelegramBotsGetDiagramTimerErrors,
  TelegramBotsGetDiagramTimerListData,
  TelegramBotsGetDiagramTimerListErrors,
  TelegramBotsGetDiagramTimerListResponses,
  TelegramBotsGetDiagramTimerResponses,
  TelegramBotsGetDiagramTriggerData,
  TelegramBotsGetDiagramTriggerErrors,
  TelegramBotsGetDiagramTriggerListData,
  TelegramBotsGetDiagramTriggerListErrors,
  TelegramBotsGetDiagramTriggerListResponses,
  TelegramBotsGetDiagramTriggerResponses,
  TelegramBotsGetInvoiceData,
  TelegramBotsGetInvoiceErrors,
  TelegramBotsGetInvoiceListData,
  TelegramBotsGetInvoiceListErrors,
  TelegramBotsGetInvoiceListResponses,
  TelegramBotsGetInvoiceResponses,
  TelegramBotsGetMessageData,
  TelegramBotsGetMessageErrors,
  TelegramBotsGetMessageListData,
  TelegramBotsGetMessageListErrors,
  TelegramBotsGetMessageListResponses,
  TelegramBotsGetMessageResponses,
  TelegramBotsGetRandomizerData,
  TelegramBotsGetRandomizerErrors,
  TelegramBotsGetRandomizerListData,
  TelegramBotsGetRandomizerListErrors,
  TelegramBotsGetRandomizerListResponses,
  TelegramBotsGetRandomizerResponses,
  TelegramBotsGetStatsData,
  TelegramBotsGetStatsErrors,
  TelegramBotsGetStatsResponses,
  TelegramBotsGetTelegramBotData,
  TelegramBotsGetTelegramBotErrors,
  TelegramBotsGetTelegramBotListData,
  TelegramBotsGetTelegramBotListErrors,
  TelegramBotsGetTelegramBotListResponses,
  TelegramBotsGetTelegramBotResponses,
  TelegramBotsGetTemporaryVariableData,
  TelegramBotsGetTemporaryVariableErrors,
  TelegramBotsGetTemporaryVariableListData,
  TelegramBotsGetTemporaryVariableListErrors,
  TelegramBotsGetTemporaryVariableListResponses,
  TelegramBotsGetTemporaryVariableResponses,
  TelegramBotsGetTimerData,
  TelegramBotsGetTimerErrors,
  TelegramBotsGetTimerListData,
  TelegramBotsGetTimerListErrors,
  TelegramBotsGetTimerListResponses,
  TelegramBotsGetTimerResponses,
  TelegramBotsGetTriggerData,
  TelegramBotsGetTriggerErrors,
  TelegramBotsGetTriggerListData,
  TelegramBotsGetTriggerListErrors,
  TelegramBotsGetTriggerListResponses,
  TelegramBotsGetTriggerResponses,
  TelegramBotsGetUserData,
  TelegramBotsGetUserErrors,
  TelegramBotsGetUserListData,
  TelegramBotsGetUserListErrors,
  TelegramBotsGetUserListResponses,
  TelegramBotsGetUserResponses,
  TelegramBotsGetUserTimelineStatsData,
  TelegramBotsGetUserTimelineStatsErrors,
  TelegramBotsGetUserTimelineStatsResponses,
  TelegramBotsGetVariableData,
  TelegramBotsGetVariableErrors,
  TelegramBotsGetVariableListData,
  TelegramBotsGetVariableListErrors,
  TelegramBotsGetVariableListResponses,
  TelegramBotsGetVariableResponses,
  TelegramBotsPartialUpdateApiRequestData,
  TelegramBotsPartialUpdateApiRequestErrors,
  TelegramBotsPartialUpdateApiRequestResponses,
  TelegramBotsPartialUpdateBackgroundTaskData,
  TelegramBotsPartialUpdateBackgroundTaskErrors,
  TelegramBotsPartialUpdateBackgroundTaskResponses,
  TelegramBotsPartialUpdateChatData,
  TelegramBotsPartialUpdateChatErrors,
  TelegramBotsPartialUpdateChatResponses,
  TelegramBotsPartialUpdateConditionData,
  TelegramBotsPartialUpdateConditionErrors,
  TelegramBotsPartialUpdateConditionResponses,
  TelegramBotsPartialUpdateDatabaseOperationData,
  TelegramBotsPartialUpdateDatabaseOperationErrors,
  TelegramBotsPartialUpdateDatabaseOperationResponses,
  TelegramBotsPartialUpdateDatabaseRecordData,
  TelegramBotsPartialUpdateDatabaseRecordErrors,
  TelegramBotsPartialUpdateDatabaseRecordResponses,
  TelegramBotsPartialUpdateDiagramApiRequestData,
  TelegramBotsPartialUpdateDiagramApiRequestErrors,
  TelegramBotsPartialUpdateDiagramApiRequestResponses,
  TelegramBotsPartialUpdateDiagramBackgroundTaskData,
  TelegramBotsPartialUpdateDiagramBackgroundTaskErrors,
  TelegramBotsPartialUpdateDiagramBackgroundTaskResponses,
  TelegramBotsPartialUpdateDiagramConditionData,
  TelegramBotsPartialUpdateDiagramConditionErrors,
  TelegramBotsPartialUpdateDiagramConditionResponses,
  TelegramBotsPartialUpdateDiagramDatabaseOperationData,
  TelegramBotsPartialUpdateDiagramDatabaseOperationErrors,
  TelegramBotsPartialUpdateDiagramDatabaseOperationResponses,
  TelegramBotsPartialUpdateDiagramInvoiceData,
  TelegramBotsPartialUpdateDiagramInvoiceErrors,
  TelegramBotsPartialUpdateDiagramInvoiceResponses,
  TelegramBotsPartialUpdateDiagramMessageData,
  TelegramBotsPartialUpdateDiagramMessageErrors,
  TelegramBotsPartialUpdateDiagramMessageResponses,
  TelegramBotsPartialUpdateDiagramRandomizerData,
  TelegramBotsPartialUpdateDiagramRandomizerErrors,
  TelegramBotsPartialUpdateDiagramRandomizerResponses,
  TelegramBotsPartialUpdateDiagramTemporaryVariableData,
  TelegramBotsPartialUpdateDiagramTemporaryVariableErrors,
  TelegramBotsPartialUpdateDiagramTemporaryVariableResponses,
  TelegramBotsPartialUpdateDiagramTimerData,
  TelegramBotsPartialUpdateDiagramTimerErrors,
  TelegramBotsPartialUpdateDiagramTimerResponses,
  TelegramBotsPartialUpdateDiagramTriggerData,
  TelegramBotsPartialUpdateDiagramTriggerErrors,
  TelegramBotsPartialUpdateDiagramTriggerResponses,
  TelegramBotsPartialUpdateInvoiceData,
  TelegramBotsPartialUpdateInvoiceErrors,
  TelegramBotsPartialUpdateInvoiceResponses,
  TelegramBotsPartialUpdateMessageData,
  TelegramBotsPartialUpdateMessageErrors,
  TelegramBotsPartialUpdateMessageResponses,
  TelegramBotsPartialUpdateRandomizerData,
  TelegramBotsPartialUpdateRandomizerErrors,
  TelegramBotsPartialUpdateRandomizerResponses,
  TelegramBotsPartialUpdateTelegramBotData,
  TelegramBotsPartialUpdateTelegramBotErrors,
  TelegramBotsPartialUpdateTelegramBotResponses,
  TelegramBotsPartialUpdateTemporaryVariableData,
  TelegramBotsPartialUpdateTemporaryVariableErrors,
  TelegramBotsPartialUpdateTemporaryVariableResponses,
  TelegramBotsPartialUpdateTimerData,
  TelegramBotsPartialUpdateTimerErrors,
  TelegramBotsPartialUpdateTimerResponses,
  TelegramBotsPartialUpdateTriggerData,
  TelegramBotsPartialUpdateTriggerErrors,
  TelegramBotsPartialUpdateTriggerResponses,
  TelegramBotsPartialUpdateUserData,
  TelegramBotsPartialUpdateUserErrors,
  TelegramBotsPartialUpdateUserResponses,
  TelegramBotsPartialUpdateVariableData,
  TelegramBotsPartialUpdateVariableErrors,
  TelegramBotsPartialUpdateVariableResponses,
  TelegramBotsPostTelegramBotRestartData,
  TelegramBotsPostTelegramBotRestartErrors,
  TelegramBotsPostTelegramBotRestartResponses,
  TelegramBotsPostTelegramBotStartData,
  TelegramBotsPostTelegramBotStartErrors,
  TelegramBotsPostTelegramBotStartResponses,
  TelegramBotsPostTelegramBotStopData,
  TelegramBotsPostTelegramBotStopErrors,
  TelegramBotsPostTelegramBotStopResponses,
  TelegramBotsUpdateApiRequestData,
  TelegramBotsUpdateApiRequestErrors,
  TelegramBotsUpdateApiRequestResponses,
  TelegramBotsUpdateBackgroundTaskData,
  TelegramBotsUpdateBackgroundTaskErrors,
  TelegramBotsUpdateBackgroundTaskResponses,
  TelegramBotsUpdateChatData,
  TelegramBotsUpdateChatErrors,
  TelegramBotsUpdateChatResponses,
  TelegramBotsUpdateConditionData,
  TelegramBotsUpdateConditionErrors,
  TelegramBotsUpdateConditionResponses,
  TelegramBotsUpdateDatabaseOperationData,
  TelegramBotsUpdateDatabaseOperationErrors,
  TelegramBotsUpdateDatabaseOperationResponses,
  TelegramBotsUpdateDatabaseRecordData,
  TelegramBotsUpdateDatabaseRecordErrors,
  TelegramBotsUpdateDatabaseRecordResponses,
  TelegramBotsUpdateDiagramApiRequestData,
  TelegramBotsUpdateDiagramApiRequestErrors,
  TelegramBotsUpdateDiagramApiRequestResponses,
  TelegramBotsUpdateDiagramBackgroundTaskData,
  TelegramBotsUpdateDiagramBackgroundTaskErrors,
  TelegramBotsUpdateDiagramBackgroundTaskResponses,
  TelegramBotsUpdateDiagramConditionData,
  TelegramBotsUpdateDiagramConditionErrors,
  TelegramBotsUpdateDiagramConditionResponses,
  TelegramBotsUpdateDiagramDatabaseOperationData,
  TelegramBotsUpdateDiagramDatabaseOperationErrors,
  TelegramBotsUpdateDiagramDatabaseOperationResponses,
  TelegramBotsUpdateDiagramInvoiceData,
  TelegramBotsUpdateDiagramInvoiceErrors,
  TelegramBotsUpdateDiagramInvoiceResponses,
  TelegramBotsUpdateDiagramMessageData,
  TelegramBotsUpdateDiagramMessageErrors,
  TelegramBotsUpdateDiagramMessageResponses,
  TelegramBotsUpdateDiagramRandomizerData,
  TelegramBotsUpdateDiagramRandomizerErrors,
  TelegramBotsUpdateDiagramRandomizerResponses,
  TelegramBotsUpdateDiagramTemporaryVariableData,
  TelegramBotsUpdateDiagramTemporaryVariableErrors,
  TelegramBotsUpdateDiagramTemporaryVariableResponses,
  TelegramBotsUpdateDiagramTimerData,
  TelegramBotsUpdateDiagramTimerErrors,
  TelegramBotsUpdateDiagramTimerResponses,
  TelegramBotsUpdateDiagramTriggerData,
  TelegramBotsUpdateDiagramTriggerErrors,
  TelegramBotsUpdateDiagramTriggerResponses,
  TelegramBotsUpdateInvoiceData,
  TelegramBotsUpdateInvoiceErrors,
  TelegramBotsUpdateInvoiceResponses,
  TelegramBotsUpdateMessageData,
  TelegramBotsUpdateMessageErrors,
  TelegramBotsUpdateMessageResponses,
  TelegramBotsUpdateRandomizerData,
  TelegramBotsUpdateRandomizerErrors,
  TelegramBotsUpdateRandomizerResponses,
  TelegramBotsUpdateTelegramBotData,
  TelegramBotsUpdateTelegramBotErrors,
  TelegramBotsUpdateTelegramBotResponses,
  TelegramBotsUpdateTemporaryVariableData,
  TelegramBotsUpdateTemporaryVariableErrors,
  TelegramBotsUpdateTemporaryVariableResponses,
  TelegramBotsUpdateTimerData,
  TelegramBotsUpdateTimerErrors,
  TelegramBotsUpdateTimerResponses,
  TelegramBotsUpdateTriggerData,
  TelegramBotsUpdateTriggerErrors,
  TelegramBotsUpdateTriggerResponses,
  TelegramBotsUpdateUserData,
  TelegramBotsUpdateUserErrors,
  TelegramBotsUpdateUserResponses,
  TelegramBotsUpdateVariableData,
  TelegramBotsUpdateVariableErrors,
  TelegramBotsUpdateVariableResponses,
  UsersDeleteUserData,
  UsersDeleteUserErrors,
  UsersDeleteUserResponses,
  UsersGetStatsData,
  UsersGetStatsErrors,
  UsersGetStatsResponses,
  UsersGetTokenData,
  UsersGetTokenErrors,
  UsersGetTokenListData,
  UsersGetTokenListErrors,
  UsersGetTokenListResponses,
  UsersGetTokenResponses,
  UsersGetUserData,
  UsersGetUserErrors,
  UsersGetUserResponses,
  UsersPostUserAcceptTermsData,
  UsersPostUserAcceptTermsErrors,
  UsersPostUserAcceptTermsResponses,
  UsersPostUserLoginData,
  UsersPostUserLoginErrors,
  UsersPostUserLoginInitData,
  UsersPostUserLoginInitErrors,
  UsersPostUserLoginInitResponses,
  UsersPostUserLoginResponses,
  UsersPostUserLogoutAllData,
  UsersPostUserLogoutAllErrors,
  UsersPostUserLogoutAllResponses,
  UsersPostUserLogoutData,
  UsersPostUserLogoutErrors,
  UsersPostUserLogoutResponses,
  UsersPostUserTokenRefreshData,
  UsersPostUserTokenRefreshErrors,
  UsersPostUserTokenRefreshResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export class InstructionService {
  public static getSectionList<ThrowOnError extends boolean = false>(
    options?: Options<InstructionGetSectionListData, ThrowOnError>,
  ): RequestResult<
    InstructionGetSectionListResponses,
    InstructionGetSectionListErrors,
    ThrowOnError
  > {
    return (options?.client ?? client).get<
      InstructionGetSectionListResponses,
      InstructionGetSectionListErrors,
      ThrowOnError
    >({ url: '/api/instruction/sections/', ...options });
  }
}

export class LegalService {
  public static getDocument<ThrowOnError extends boolean = false>(
    options: Options<LegalGetDocumentData, ThrowOnError>,
  ): RequestResult<LegalGetDocumentResponses, LegalGetDocumentErrors, ThrowOnError> {
    return (options.client ?? client).get<
      LegalGetDocumentResponses,
      LegalGetDocumentErrors,
      ThrowOnError
    >({ url: '/api/legal/documents/{type}/', ...options });
  }
}

export class PremiumService {
  public static getSubscriptionInvoiceList<ThrowOnError extends boolean = false>(
    options?: Options<PremiumGetSubscriptionInvoiceListData, ThrowOnError>,
  ): RequestResult<
    PremiumGetSubscriptionInvoiceListResponses,
    PremiumGetSubscriptionInvoiceListErrors,
    ThrowOnError
  > {
    return (options?.client ?? client).get<
      PremiumGetSubscriptionInvoiceListResponses,
      PremiumGetSubscriptionInvoiceListErrors,
      ThrowOnError
    >({
      querySerializer: { parameters: { statuses: { array: { explode: false } } } },
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/premium/subscription-invoices/',
      ...options,
    });
  }

  public static getSubscriptionInvoice<ThrowOnError extends boolean = false>(
    options: Options<PremiumGetSubscriptionInvoiceData, ThrowOnError>,
  ): RequestResult<
    PremiumGetSubscriptionInvoiceResponses,
    PremiumGetSubscriptionInvoiceErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      PremiumGetSubscriptionInvoiceResponses,
      PremiumGetSubscriptionInvoiceErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/premium/subscription-invoices/{id}/',
      ...options,
    });
  }

  public static getSubscriptionPriceList<ThrowOnError extends boolean = false>(
    options?: Options<PremiumGetSubscriptionPriceListData, ThrowOnError>,
  ): RequestResult<
    PremiumGetSubscriptionPriceListResponses,
    PremiumGetSubscriptionPriceListErrors,
    ThrowOnError
  > {
    return (options?.client ?? client).get<
      PremiumGetSubscriptionPriceListResponses,
      PremiumGetSubscriptionPriceListErrors,
      ThrowOnError
    >({ url: '/api/premium/subscription-prices/', ...options });
  }

  public static getSubscriptionPrice<ThrowOnError extends boolean = false>(
    options: Options<PremiumGetSubscriptionPriceData, ThrowOnError>,
  ): RequestResult<
    PremiumGetSubscriptionPriceResponses,
    PremiumGetSubscriptionPriceErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      PremiumGetSubscriptionPriceResponses,
      PremiumGetSubscriptionPriceErrors,
      ThrowOnError
    >({ url: '/api/premium/subscription-prices/{id}/', ...options });
  }

  public static getSubscriptionPriceCheckout<ThrowOnError extends boolean = false>(
    options: Options<PremiumGetSubscriptionPriceCheckoutData, ThrowOnError>,
  ): RequestResult<
    PremiumGetSubscriptionPriceCheckoutResponses,
    PremiumGetSubscriptionPriceCheckoutErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      PremiumGetSubscriptionPriceCheckoutResponses,
      PremiumGetSubscriptionPriceCheckoutErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/premium/subscription-prices/{id}/checkout/',
      ...options,
    });
  }
}

export class TelegramBotsService {
  public static getTelegramBotList<ThrowOnError extends boolean = false>(
    options?: Options<TelegramBotsGetTelegramBotListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetTelegramBotListResponses,
    TelegramBotsGetTelegramBotListErrors,
    ThrowOnError
  > {
    return (options?.client ?? client).get<
      TelegramBotsGetTelegramBotListResponses,
      TelegramBotsGetTelegramBotListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/',
      ...options,
    });
  }

  public static createTelegramBot<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsCreateTelegramBotData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsCreateTelegramBotResponses,
    TelegramBotsCreateTelegramBotErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsCreateTelegramBotResponses,
      TelegramBotsCreateTelegramBotErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteTelegramBot<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteTelegramBotData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteTelegramBotResponses,
    TelegramBotsDeleteTelegramBotErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteTelegramBotResponses,
      TelegramBotsDeleteTelegramBotErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{id}/',
      ...options,
    });
  }

  public static getTelegramBot<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetTelegramBotData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetTelegramBotResponses,
    TelegramBotsGetTelegramBotErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetTelegramBotResponses,
      TelegramBotsGetTelegramBotErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{id}/',
      ...options,
    });
  }

  public static partialUpdateTelegramBot<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateTelegramBotData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateTelegramBotResponses,
    TelegramBotsPartialUpdateTelegramBotErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateTelegramBotResponses,
      TelegramBotsPartialUpdateTelegramBotErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateTelegramBot<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateTelegramBotData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateTelegramBotResponses,
    TelegramBotsUpdateTelegramBotErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateTelegramBotResponses,
      TelegramBotsUpdateTelegramBotErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static postTelegramBotRestart<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPostTelegramBotRestartData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPostTelegramBotRestartResponses,
    TelegramBotsPostTelegramBotRestartErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsPostTelegramBotRestartResponses,
      TelegramBotsPostTelegramBotRestartErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{id}/restart/',
      ...options,
    });
  }

  public static postTelegramBotStart<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPostTelegramBotStartData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPostTelegramBotStartResponses,
    TelegramBotsPostTelegramBotStartErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsPostTelegramBotStartResponses,
      TelegramBotsPostTelegramBotStartErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{id}/start/',
      ...options,
    });
  }

  public static postTelegramBotStop<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPostTelegramBotStopData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPostTelegramBotStopResponses,
    TelegramBotsPostTelegramBotStopErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsPostTelegramBotStopResponses,
      TelegramBotsPostTelegramBotStopErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{id}/stop/',
      ...options,
    });
  }

  public static getApiRequestList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetApiRequestListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetApiRequestListResponses,
    TelegramBotsGetApiRequestListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetApiRequestListResponses,
      TelegramBotsGetApiRequestListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/api-requests/',
      ...options,
    });
  }

  public static createApiRequest<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsCreateApiRequestData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsCreateApiRequestResponses,
    TelegramBotsCreateApiRequestErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsCreateApiRequestResponses,
      TelegramBotsCreateApiRequestErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/api-requests/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteApiRequest<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteApiRequestData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteApiRequestResponses,
    TelegramBotsDeleteApiRequestErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteApiRequestResponses,
      TelegramBotsDeleteApiRequestErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/api-requests/{id}/',
      ...options,
    });
  }

  public static getApiRequest<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetApiRequestData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetApiRequestResponses,
    TelegramBotsGetApiRequestErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetApiRequestResponses,
      TelegramBotsGetApiRequestErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/api-requests/{id}/',
      ...options,
    });
  }

  public static partialUpdateApiRequest<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateApiRequestData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateApiRequestResponses,
    TelegramBotsPartialUpdateApiRequestErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateApiRequestResponses,
      TelegramBotsPartialUpdateApiRequestErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/api-requests/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateApiRequest<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateApiRequestData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateApiRequestResponses,
    TelegramBotsUpdateApiRequestErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateApiRequestResponses,
      TelegramBotsUpdateApiRequestErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/api-requests/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getBackgroundTaskList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetBackgroundTaskListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetBackgroundTaskListResponses,
    TelegramBotsGetBackgroundTaskListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetBackgroundTaskListResponses,
      TelegramBotsGetBackgroundTaskListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/background-tasks/',
      ...options,
    });
  }

  public static createBackgroundTask<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsCreateBackgroundTaskData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsCreateBackgroundTaskResponses,
    TelegramBotsCreateBackgroundTaskErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsCreateBackgroundTaskResponses,
      TelegramBotsCreateBackgroundTaskErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/background-tasks/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteBackgroundTask<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteBackgroundTaskData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteBackgroundTaskResponses,
    TelegramBotsDeleteBackgroundTaskErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteBackgroundTaskResponses,
      TelegramBotsDeleteBackgroundTaskErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/background-tasks/{id}/',
      ...options,
    });
  }

  public static getBackgroundTask<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetBackgroundTaskData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetBackgroundTaskResponses,
    TelegramBotsGetBackgroundTaskErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetBackgroundTaskResponses,
      TelegramBotsGetBackgroundTaskErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/background-tasks/{id}/',
      ...options,
    });
  }

  public static partialUpdateBackgroundTask<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateBackgroundTaskData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateBackgroundTaskResponses,
    TelegramBotsPartialUpdateBackgroundTaskErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateBackgroundTaskResponses,
      TelegramBotsPartialUpdateBackgroundTaskErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/background-tasks/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateBackgroundTask<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateBackgroundTaskData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateBackgroundTaskResponses,
    TelegramBotsUpdateBackgroundTaskErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateBackgroundTaskResponses,
      TelegramBotsUpdateBackgroundTaskErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/background-tasks/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getChatList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetChatListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetChatListResponses,
    TelegramBotsGetChatListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetChatListResponses,
      TelegramBotsGetChatListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/chats/',
      ...options,
    });
  }

  public static deleteChat<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteChatData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteChatResponses,
    TelegramBotsDeleteChatErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteChatResponses,
      TelegramBotsDeleteChatErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/chats/{id}/',
      ...options,
    });
  }

  public static getChat<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetChatData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetChatResponses,
    TelegramBotsGetChatErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetChatResponses,
      TelegramBotsGetChatErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/chats/{id}/',
      ...options,
    });
  }

  public static partialUpdateChat<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateChatData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateChatResponses,
    TelegramBotsPartialUpdateChatErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateChatResponses,
      TelegramBotsPartialUpdateChatErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/chats/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateChat<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateChatData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateChatResponses,
    TelegramBotsUpdateChatErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateChatResponses,
      TelegramBotsUpdateChatErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/chats/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getConditionList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetConditionListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetConditionListResponses,
    TelegramBotsGetConditionListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetConditionListResponses,
      TelegramBotsGetConditionListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/conditions/',
      ...options,
    });
  }

  public static createCondition<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsCreateConditionData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsCreateConditionResponses,
    TelegramBotsCreateConditionErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsCreateConditionResponses,
      TelegramBotsCreateConditionErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/conditions/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteCondition<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteConditionData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteConditionResponses,
    TelegramBotsDeleteConditionErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteConditionResponses,
      TelegramBotsDeleteConditionErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/conditions/{id}/',
      ...options,
    });
  }

  public static getCondition<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetConditionData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetConditionResponses,
    TelegramBotsGetConditionErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetConditionResponses,
      TelegramBotsGetConditionErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/conditions/{id}/',
      ...options,
    });
  }

  public static partialUpdateCondition<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateConditionData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateConditionResponses,
    TelegramBotsPartialUpdateConditionErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateConditionResponses,
      TelegramBotsPartialUpdateConditionErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/conditions/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateCondition<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateConditionData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateConditionResponses,
    TelegramBotsUpdateConditionErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateConditionResponses,
      TelegramBotsUpdateConditionErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/conditions/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static createConnection<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsCreateConnectionData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsCreateConnectionResponses,
    TelegramBotsCreateConnectionErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsCreateConnectionResponses,
      TelegramBotsCreateConnectionErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/connections/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteConnection<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteConnectionData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteConnectionResponses,
    TelegramBotsDeleteConnectionErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteConnectionResponses,
      TelegramBotsDeleteConnectionErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/connections/{id}/',
      ...options,
    });
  }

  public static getDatabaseOperationList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDatabaseOperationListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDatabaseOperationListResponses,
    TelegramBotsGetDatabaseOperationListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDatabaseOperationListResponses,
      TelegramBotsGetDatabaseOperationListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/database-operations/',
      ...options,
    });
  }

  public static createDatabaseOperation<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsCreateDatabaseOperationData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsCreateDatabaseOperationResponses,
    TelegramBotsCreateDatabaseOperationErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsCreateDatabaseOperationResponses,
      TelegramBotsCreateDatabaseOperationErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/database-operations/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteDatabaseOperation<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteDatabaseOperationData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteDatabaseOperationResponses,
    TelegramBotsDeleteDatabaseOperationErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteDatabaseOperationResponses,
      TelegramBotsDeleteDatabaseOperationErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/database-operations/{id}/',
      ...options,
    });
  }

  public static getDatabaseOperation<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDatabaseOperationData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDatabaseOperationResponses,
    TelegramBotsGetDatabaseOperationErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDatabaseOperationResponses,
      TelegramBotsGetDatabaseOperationErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/database-operations/{id}/',
      ...options,
    });
  }

  public static partialUpdateDatabaseOperation<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateDatabaseOperationData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateDatabaseOperationResponses,
    TelegramBotsPartialUpdateDatabaseOperationErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateDatabaseOperationResponses,
      TelegramBotsPartialUpdateDatabaseOperationErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/database-operations/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateDatabaseOperation<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateDatabaseOperationData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateDatabaseOperationResponses,
    TelegramBotsUpdateDatabaseOperationErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateDatabaseOperationResponses,
      TelegramBotsUpdateDatabaseOperationErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/database-operations/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getDatabaseRecordList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDatabaseRecordListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDatabaseRecordListResponses,
    TelegramBotsGetDatabaseRecordListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDatabaseRecordListResponses,
      TelegramBotsGetDatabaseRecordListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/database-records/',
      ...options,
    });
  }

  public static createDatabaseRecord<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsCreateDatabaseRecordData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsCreateDatabaseRecordResponses,
    TelegramBotsCreateDatabaseRecordErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsCreateDatabaseRecordResponses,
      TelegramBotsCreateDatabaseRecordErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/database-records/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteDatabaseRecord<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteDatabaseRecordData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteDatabaseRecordResponses,
    TelegramBotsDeleteDatabaseRecordErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteDatabaseRecordResponses,
      TelegramBotsDeleteDatabaseRecordErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/database-records/{id}/',
      ...options,
    });
  }

  public static getDatabaseRecord<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDatabaseRecordData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDatabaseRecordResponses,
    TelegramBotsGetDatabaseRecordErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDatabaseRecordResponses,
      TelegramBotsGetDatabaseRecordErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/database-records/{id}/',
      ...options,
    });
  }

  public static partialUpdateDatabaseRecord<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateDatabaseRecordData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateDatabaseRecordResponses,
    TelegramBotsPartialUpdateDatabaseRecordErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateDatabaseRecordResponses,
      TelegramBotsPartialUpdateDatabaseRecordErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/database-records/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateDatabaseRecord<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateDatabaseRecordData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateDatabaseRecordResponses,
    TelegramBotsUpdateDatabaseRecordErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateDatabaseRecordResponses,
      TelegramBotsUpdateDatabaseRecordErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/database-records/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getDiagramApiRequestList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramApiRequestListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramApiRequestListResponses,
    TelegramBotsGetDiagramApiRequestListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramApiRequestListResponses,
      TelegramBotsGetDiagramApiRequestListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/api-requests/',
      ...options,
    });
  }

  public static getDiagramApiRequest<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramApiRequestData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramApiRequestResponses,
    TelegramBotsGetDiagramApiRequestErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramApiRequestResponses,
      TelegramBotsGetDiagramApiRequestErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/api-requests/{id}/',
      ...options,
    });
  }

  public static partialUpdateDiagramApiRequest<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateDiagramApiRequestData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateDiagramApiRequestResponses,
    TelegramBotsPartialUpdateDiagramApiRequestErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateDiagramApiRequestResponses,
      TelegramBotsPartialUpdateDiagramApiRequestErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/api-requests/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateDiagramApiRequest<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateDiagramApiRequestData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateDiagramApiRequestResponses,
    TelegramBotsUpdateDiagramApiRequestErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateDiagramApiRequestResponses,
      TelegramBotsUpdateDiagramApiRequestErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/api-requests/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getDiagramBackgroundTaskList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramBackgroundTaskListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramBackgroundTaskListResponses,
    TelegramBotsGetDiagramBackgroundTaskListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramBackgroundTaskListResponses,
      TelegramBotsGetDiagramBackgroundTaskListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/background-tasks/',
      ...options,
    });
  }

  public static getDiagramBackgroundTask<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramBackgroundTaskData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramBackgroundTaskResponses,
    TelegramBotsGetDiagramBackgroundTaskErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramBackgroundTaskResponses,
      TelegramBotsGetDiagramBackgroundTaskErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/background-tasks/{id}/',
      ...options,
    });
  }

  public static partialUpdateDiagramBackgroundTask<
    ThrowOnError extends boolean = false,
  >(
    options: Options<TelegramBotsPartialUpdateDiagramBackgroundTaskData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateDiagramBackgroundTaskResponses,
    TelegramBotsPartialUpdateDiagramBackgroundTaskErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateDiagramBackgroundTaskResponses,
      TelegramBotsPartialUpdateDiagramBackgroundTaskErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/background-tasks/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateDiagramBackgroundTask<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateDiagramBackgroundTaskData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateDiagramBackgroundTaskResponses,
    TelegramBotsUpdateDiagramBackgroundTaskErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateDiagramBackgroundTaskResponses,
      TelegramBotsUpdateDiagramBackgroundTaskErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/background-tasks/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getDiagramConditionList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramConditionListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramConditionListResponses,
    TelegramBotsGetDiagramConditionListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramConditionListResponses,
      TelegramBotsGetDiagramConditionListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/conditions/',
      ...options,
    });
  }

  public static getDiagramCondition<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramConditionData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramConditionResponses,
    TelegramBotsGetDiagramConditionErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramConditionResponses,
      TelegramBotsGetDiagramConditionErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/conditions/{id}/',
      ...options,
    });
  }

  public static partialUpdateDiagramCondition<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateDiagramConditionData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateDiagramConditionResponses,
    TelegramBotsPartialUpdateDiagramConditionErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateDiagramConditionResponses,
      TelegramBotsPartialUpdateDiagramConditionErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/conditions/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateDiagramCondition<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateDiagramConditionData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateDiagramConditionResponses,
    TelegramBotsUpdateDiagramConditionErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateDiagramConditionResponses,
      TelegramBotsUpdateDiagramConditionErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/conditions/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getDiagramDatabaseOperationList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramDatabaseOperationListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramDatabaseOperationListResponses,
    TelegramBotsGetDiagramDatabaseOperationListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramDatabaseOperationListResponses,
      TelegramBotsGetDiagramDatabaseOperationListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/database-operations/',
      ...options,
    });
  }

  public static getDiagramDatabaseOperation<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramDatabaseOperationData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramDatabaseOperationResponses,
    TelegramBotsGetDiagramDatabaseOperationErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramDatabaseOperationResponses,
      TelegramBotsGetDiagramDatabaseOperationErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/database-operations/{id}/',
      ...options,
    });
  }

  public static partialUpdateDiagramDatabaseOperation<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      TelegramBotsPartialUpdateDiagramDatabaseOperationData,
      ThrowOnError
    >,
  ): RequestResult<
    TelegramBotsPartialUpdateDiagramDatabaseOperationResponses,
    TelegramBotsPartialUpdateDiagramDatabaseOperationErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateDiagramDatabaseOperationResponses,
      TelegramBotsPartialUpdateDiagramDatabaseOperationErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/database-operations/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateDiagramDatabaseOperation<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateDiagramDatabaseOperationData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateDiagramDatabaseOperationResponses,
    TelegramBotsUpdateDiagramDatabaseOperationErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateDiagramDatabaseOperationResponses,
      TelegramBotsUpdateDiagramDatabaseOperationErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/database-operations/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getDiagramInvoiceList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramInvoiceListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramInvoiceListResponses,
    TelegramBotsGetDiagramInvoiceListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramInvoiceListResponses,
      TelegramBotsGetDiagramInvoiceListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/invoices/',
      ...options,
    });
  }

  public static getDiagramInvoice<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramInvoiceData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramInvoiceResponses,
    TelegramBotsGetDiagramInvoiceErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramInvoiceResponses,
      TelegramBotsGetDiagramInvoiceErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/invoices/{id}/',
      ...options,
    });
  }

  public static partialUpdateDiagramInvoice<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateDiagramInvoiceData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateDiagramInvoiceResponses,
    TelegramBotsPartialUpdateDiagramInvoiceErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateDiagramInvoiceResponses,
      TelegramBotsPartialUpdateDiagramInvoiceErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/invoices/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateDiagramInvoice<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateDiagramInvoiceData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateDiagramInvoiceResponses,
    TelegramBotsUpdateDiagramInvoiceErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateDiagramInvoiceResponses,
      TelegramBotsUpdateDiagramInvoiceErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/invoices/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getDiagramMessageList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramMessageListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramMessageListResponses,
    TelegramBotsGetDiagramMessageListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramMessageListResponses,
      TelegramBotsGetDiagramMessageListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/messages/',
      ...options,
    });
  }

  public static getDiagramMessage<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramMessageData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramMessageResponses,
    TelegramBotsGetDiagramMessageErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramMessageResponses,
      TelegramBotsGetDiagramMessageErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/messages/{id}/',
      ...options,
    });
  }

  public static partialUpdateDiagramMessage<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateDiagramMessageData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateDiagramMessageResponses,
    TelegramBotsPartialUpdateDiagramMessageErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateDiagramMessageResponses,
      TelegramBotsPartialUpdateDiagramMessageErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/messages/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateDiagramMessage<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateDiagramMessageData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateDiagramMessageResponses,
    TelegramBotsUpdateDiagramMessageErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateDiagramMessageResponses,
      TelegramBotsUpdateDiagramMessageErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/messages/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getDiagramRandomizerList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramRandomizerListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramRandomizerListResponses,
    TelegramBotsGetDiagramRandomizerListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramRandomizerListResponses,
      TelegramBotsGetDiagramRandomizerListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/randomizers/',
      ...options,
    });
  }

  public static createDiagramRandomizer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsCreateDiagramRandomizerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsCreateDiagramRandomizerResponses,
    TelegramBotsCreateDiagramRandomizerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsCreateDiagramRandomizerResponses,
      TelegramBotsCreateDiagramRandomizerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/randomizers/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteDiagramRandomizer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteDiagramRandomizerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteDiagramRandomizerResponses,
    TelegramBotsDeleteDiagramRandomizerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteDiagramRandomizerResponses,
      TelegramBotsDeleteDiagramRandomizerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/randomizers/{id}/',
      ...options,
    });
  }

  public static getDiagramRandomizer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramRandomizerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramRandomizerResponses,
    TelegramBotsGetDiagramRandomizerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramRandomizerResponses,
      TelegramBotsGetDiagramRandomizerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/randomizers/{id}/',
      ...options,
    });
  }

  public static partialUpdateDiagramRandomizer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateDiagramRandomizerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateDiagramRandomizerResponses,
    TelegramBotsPartialUpdateDiagramRandomizerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateDiagramRandomizerResponses,
      TelegramBotsPartialUpdateDiagramRandomizerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/randomizers/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateDiagramRandomizer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateDiagramRandomizerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateDiagramRandomizerResponses,
    TelegramBotsUpdateDiagramRandomizerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateDiagramRandomizerResponses,
      TelegramBotsUpdateDiagramRandomizerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/randomizers/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getDiagramTemporaryVariableList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramTemporaryVariableListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramTemporaryVariableListResponses,
    TelegramBotsGetDiagramTemporaryVariableListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramTemporaryVariableListResponses,
      TelegramBotsGetDiagramTemporaryVariableListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/temporary-variables/',
      ...options,
    });
  }

  public static getDiagramTemporaryVariable<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramTemporaryVariableData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramTemporaryVariableResponses,
    TelegramBotsGetDiagramTemporaryVariableErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramTemporaryVariableResponses,
      TelegramBotsGetDiagramTemporaryVariableErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/temporary-variables/{id}/',
      ...options,
    });
  }

  public static partialUpdateDiagramTemporaryVariable<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      TelegramBotsPartialUpdateDiagramTemporaryVariableData,
      ThrowOnError
    >,
  ): RequestResult<
    TelegramBotsPartialUpdateDiagramTemporaryVariableResponses,
    TelegramBotsPartialUpdateDiagramTemporaryVariableErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateDiagramTemporaryVariableResponses,
      TelegramBotsPartialUpdateDiagramTemporaryVariableErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/temporary-variables/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateDiagramTemporaryVariable<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateDiagramTemporaryVariableData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateDiagramTemporaryVariableResponses,
    TelegramBotsUpdateDiagramTemporaryVariableErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateDiagramTemporaryVariableResponses,
      TelegramBotsUpdateDiagramTemporaryVariableErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/temporary-variables/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getDiagramTimerList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramTimerListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramTimerListResponses,
    TelegramBotsGetDiagramTimerListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramTimerListResponses,
      TelegramBotsGetDiagramTimerListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/timers/',
      ...options,
    });
  }

  public static createDiagramTimer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsCreateDiagramTimerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsCreateDiagramTimerResponses,
    TelegramBotsCreateDiagramTimerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsCreateDiagramTimerResponses,
      TelegramBotsCreateDiagramTimerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/timers/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteDiagramTimer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteDiagramTimerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteDiagramTimerResponses,
    TelegramBotsDeleteDiagramTimerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteDiagramTimerResponses,
      TelegramBotsDeleteDiagramTimerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/timers/{id}/',
      ...options,
    });
  }

  public static getDiagramTimer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramTimerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramTimerResponses,
    TelegramBotsGetDiagramTimerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramTimerResponses,
      TelegramBotsGetDiagramTimerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/timers/{id}/',
      ...options,
    });
  }

  public static partialUpdateDiagramTimer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateDiagramTimerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateDiagramTimerResponses,
    TelegramBotsPartialUpdateDiagramTimerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateDiagramTimerResponses,
      TelegramBotsPartialUpdateDiagramTimerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/timers/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateDiagramTimer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateDiagramTimerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateDiagramTimerResponses,
    TelegramBotsUpdateDiagramTimerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateDiagramTimerResponses,
      TelegramBotsUpdateDiagramTimerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/timers/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getDiagramTriggerList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramTriggerListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramTriggerListResponses,
    TelegramBotsGetDiagramTriggerListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramTriggerListResponses,
      TelegramBotsGetDiagramTriggerListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/triggers/',
      ...options,
    });
  }

  public static createDiagramTrigger<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsCreateDiagramTriggerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsCreateDiagramTriggerResponses,
    TelegramBotsCreateDiagramTriggerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsCreateDiagramTriggerResponses,
      TelegramBotsCreateDiagramTriggerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/triggers/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteDiagramTrigger<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteDiagramTriggerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteDiagramTriggerResponses,
    TelegramBotsDeleteDiagramTriggerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteDiagramTriggerResponses,
      TelegramBotsDeleteDiagramTriggerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/triggers/{id}/',
      ...options,
    });
  }

  public static getDiagramTrigger<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetDiagramTriggerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetDiagramTriggerResponses,
    TelegramBotsGetDiagramTriggerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetDiagramTriggerResponses,
      TelegramBotsGetDiagramTriggerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/triggers/{id}/',
      ...options,
    });
  }

  public static partialUpdateDiagramTrigger<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateDiagramTriggerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateDiagramTriggerResponses,
    TelegramBotsPartialUpdateDiagramTriggerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateDiagramTriggerResponses,
      TelegramBotsPartialUpdateDiagramTriggerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/triggers/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateDiagramTrigger<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateDiagramTriggerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateDiagramTriggerResponses,
    TelegramBotsUpdateDiagramTriggerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateDiagramTriggerResponses,
      TelegramBotsUpdateDiagramTriggerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/diagram/triggers/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getInvoiceList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetInvoiceListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetInvoiceListResponses,
    TelegramBotsGetInvoiceListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetInvoiceListResponses,
      TelegramBotsGetInvoiceListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/invoices/',
      ...options,
    });
  }

  public static createInvoice<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsCreateInvoiceData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsCreateInvoiceResponses,
    TelegramBotsCreateInvoiceErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsCreateInvoiceResponses,
      TelegramBotsCreateInvoiceErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/invoices/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteInvoice<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteInvoiceData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteInvoiceResponses,
    TelegramBotsDeleteInvoiceErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteInvoiceResponses,
      TelegramBotsDeleteInvoiceErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/invoices/{id}/',
      ...options,
    });
  }

  public static getInvoice<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetInvoiceData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetInvoiceResponses,
    TelegramBotsGetInvoiceErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetInvoiceResponses,
      TelegramBotsGetInvoiceErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/invoices/{id}/',
      ...options,
    });
  }

  public static partialUpdateInvoice<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateInvoiceData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateInvoiceResponses,
    TelegramBotsPartialUpdateInvoiceErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateInvoiceResponses,
      TelegramBotsPartialUpdateInvoiceErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/invoices/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateInvoice<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateInvoiceData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateInvoiceResponses,
    TelegramBotsUpdateInvoiceErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateInvoiceResponses,
      TelegramBotsUpdateInvoiceErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/invoices/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getMessageList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetMessageListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetMessageListResponses,
    TelegramBotsGetMessageListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetMessageListResponses,
      TelegramBotsGetMessageListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/messages/',
      ...options,
    });
  }

  public static createMessage<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsCreateMessageData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsCreateMessageResponses,
    TelegramBotsCreateMessageErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsCreateMessageResponses,
      TelegramBotsCreateMessageErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/messages/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteMessage<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteMessageData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteMessageResponses,
    TelegramBotsDeleteMessageErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteMessageResponses,
      TelegramBotsDeleteMessageErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/messages/{id}/',
      ...options,
    });
  }

  public static getMessage<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetMessageData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetMessageResponses,
    TelegramBotsGetMessageErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetMessageResponses,
      TelegramBotsGetMessageErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/messages/{id}/',
      ...options,
    });
  }

  public static partialUpdateMessage<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateMessageData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateMessageResponses,
    TelegramBotsPartialUpdateMessageErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateMessageResponses,
      TelegramBotsPartialUpdateMessageErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/messages/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateMessage<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateMessageData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateMessageResponses,
    TelegramBotsUpdateMessageErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateMessageResponses,
      TelegramBotsUpdateMessageErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/messages/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getRandomizerList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetRandomizerListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetRandomizerListResponses,
    TelegramBotsGetRandomizerListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetRandomizerListResponses,
      TelegramBotsGetRandomizerListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/randomizers/',
      ...options,
    });
  }

  public static createRandomizer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsCreateRandomizerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsCreateRandomizerResponses,
    TelegramBotsCreateRandomizerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsCreateRandomizerResponses,
      TelegramBotsCreateRandomizerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/randomizers/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteRandomizer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteRandomizerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteRandomizerResponses,
    TelegramBotsDeleteRandomizerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteRandomizerResponses,
      TelegramBotsDeleteRandomizerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/randomizers/{id}/',
      ...options,
    });
  }

  public static getRandomizer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetRandomizerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetRandomizerResponses,
    TelegramBotsGetRandomizerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetRandomizerResponses,
      TelegramBotsGetRandomizerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/randomizers/{id}/',
      ...options,
    });
  }

  public static partialUpdateRandomizer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateRandomizerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateRandomizerResponses,
    TelegramBotsPartialUpdateRandomizerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateRandomizerResponses,
      TelegramBotsPartialUpdateRandomizerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/randomizers/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateRandomizer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateRandomizerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateRandomizerResponses,
    TelegramBotsUpdateRandomizerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateRandomizerResponses,
      TelegramBotsUpdateRandomizerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/randomizers/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getTemporaryVariableList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetTemporaryVariableListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetTemporaryVariableListResponses,
    TelegramBotsGetTemporaryVariableListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetTemporaryVariableListResponses,
      TelegramBotsGetTemporaryVariableListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/temporary-variables/',
      ...options,
    });
  }

  public static createTemporaryVariable<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsCreateTemporaryVariableData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsCreateTemporaryVariableResponses,
    TelegramBotsCreateTemporaryVariableErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsCreateTemporaryVariableResponses,
      TelegramBotsCreateTemporaryVariableErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/temporary-variables/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteTemporaryVariable<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteTemporaryVariableData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteTemporaryVariableResponses,
    TelegramBotsDeleteTemporaryVariableErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteTemporaryVariableResponses,
      TelegramBotsDeleteTemporaryVariableErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/temporary-variables/{id}/',
      ...options,
    });
  }

  public static getTemporaryVariable<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetTemporaryVariableData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetTemporaryVariableResponses,
    TelegramBotsGetTemporaryVariableErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetTemporaryVariableResponses,
      TelegramBotsGetTemporaryVariableErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/temporary-variables/{id}/',
      ...options,
    });
  }

  public static partialUpdateTemporaryVariable<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateTemporaryVariableData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateTemporaryVariableResponses,
    TelegramBotsPartialUpdateTemporaryVariableErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateTemporaryVariableResponses,
      TelegramBotsPartialUpdateTemporaryVariableErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/temporary-variables/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateTemporaryVariable<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateTemporaryVariableData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateTemporaryVariableResponses,
    TelegramBotsUpdateTemporaryVariableErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateTemporaryVariableResponses,
      TelegramBotsUpdateTemporaryVariableErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/temporary-variables/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getTimerList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetTimerListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetTimerListResponses,
    TelegramBotsGetTimerListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetTimerListResponses,
      TelegramBotsGetTimerListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/timers/',
      ...options,
    });
  }

  public static createTimer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsCreateTimerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsCreateTimerResponses,
    TelegramBotsCreateTimerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsCreateTimerResponses,
      TelegramBotsCreateTimerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/timers/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteTimer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteTimerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteTimerResponses,
    TelegramBotsDeleteTimerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteTimerResponses,
      TelegramBotsDeleteTimerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/timers/{id}/',
      ...options,
    });
  }

  public static getTimer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetTimerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetTimerResponses,
    TelegramBotsGetTimerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetTimerResponses,
      TelegramBotsGetTimerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/timers/{id}/',
      ...options,
    });
  }

  public static partialUpdateTimer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateTimerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateTimerResponses,
    TelegramBotsPartialUpdateTimerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateTimerResponses,
      TelegramBotsPartialUpdateTimerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/timers/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateTimer<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateTimerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateTimerResponses,
    TelegramBotsUpdateTimerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateTimerResponses,
      TelegramBotsUpdateTimerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/timers/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getTriggerList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetTriggerListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetTriggerListResponses,
    TelegramBotsGetTriggerListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetTriggerListResponses,
      TelegramBotsGetTriggerListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/triggers/',
      ...options,
    });
  }

  public static createTrigger<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsCreateTriggerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsCreateTriggerResponses,
    TelegramBotsCreateTriggerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsCreateTriggerResponses,
      TelegramBotsCreateTriggerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/triggers/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteTrigger<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteTriggerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteTriggerResponses,
    TelegramBotsDeleteTriggerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteTriggerResponses,
      TelegramBotsDeleteTriggerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/triggers/{id}/',
      ...options,
    });
  }

  public static getTrigger<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetTriggerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetTriggerResponses,
    TelegramBotsGetTriggerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetTriggerResponses,
      TelegramBotsGetTriggerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/triggers/{id}/',
      ...options,
    });
  }

  public static partialUpdateTrigger<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateTriggerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateTriggerResponses,
    TelegramBotsPartialUpdateTriggerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateTriggerResponses,
      TelegramBotsPartialUpdateTriggerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/triggers/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateTrigger<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateTriggerData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateTriggerResponses,
    TelegramBotsUpdateTriggerErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateTriggerResponses,
      TelegramBotsUpdateTriggerErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/triggers/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getUserList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetUserListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetUserListResponses,
    TelegramBotsGetUserListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetUserListResponses,
      TelegramBotsGetUserListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/users/',
      ...options,
    });
  }

  public static deleteUser<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteUserData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteUserResponses,
    TelegramBotsDeleteUserErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteUserResponses,
      TelegramBotsDeleteUserErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/users/{id}/',
      ...options,
    });
  }

  public static getUser<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetUserData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetUserResponses,
    TelegramBotsGetUserErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetUserResponses,
      TelegramBotsGetUserErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/users/{id}/',
      ...options,
    });
  }

  public static partialUpdateUser<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateUserData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateUserResponses,
    TelegramBotsPartialUpdateUserErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateUserResponses,
      TelegramBotsPartialUpdateUserErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/users/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateUser<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateUserData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateUserResponses,
    TelegramBotsUpdateUserErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateUserResponses,
      TelegramBotsUpdateUserErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/users/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getUserTimelineStats<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetUserTimelineStatsData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetUserTimelineStatsResponses,
    TelegramBotsGetUserTimelineStatsErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetUserTimelineStatsResponses,
      TelegramBotsGetUserTimelineStatsErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/users/timeline-stats/',
      ...options,
    });
  }

  public static getVariableList<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetVariableListData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetVariableListResponses,
    TelegramBotsGetVariableListErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetVariableListResponses,
      TelegramBotsGetVariableListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/variables/',
      ...options,
    });
  }

  public static createVariable<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsCreateVariableData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsCreateVariableResponses,
    TelegramBotsCreateVariableErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      TelegramBotsCreateVariableResponses,
      TelegramBotsCreateVariableErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/variables/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteVariable<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsDeleteVariableData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsDeleteVariableResponses,
    TelegramBotsDeleteVariableErrors,
    ThrowOnError
  > {
    return (options.client ?? client).delete<
      TelegramBotsDeleteVariableResponses,
      TelegramBotsDeleteVariableErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/variables/{id}/',
      ...options,
    });
  }

  public static getVariable<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsGetVariableData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetVariableResponses,
    TelegramBotsGetVariableErrors,
    ThrowOnError
  > {
    return (options.client ?? client).get<
      TelegramBotsGetVariableResponses,
      TelegramBotsGetVariableErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/variables/{id}/',
      ...options,
    });
  }

  public static partialUpdateVariable<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsPartialUpdateVariableData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsPartialUpdateVariableResponses,
    TelegramBotsPartialUpdateVariableErrors,
    ThrowOnError
  > {
    return (options.client ?? client).patch<
      TelegramBotsPartialUpdateVariableResponses,
      TelegramBotsPartialUpdateVariableErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/variables/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateVariable<ThrowOnError extends boolean = false>(
    options: Options<TelegramBotsUpdateVariableData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsUpdateVariableResponses,
    TelegramBotsUpdateVariableErrors,
    ThrowOnError
  > {
    return (options.client ?? client).put<
      TelegramBotsUpdateVariableResponses,
      TelegramBotsUpdateVariableErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/telegram-bots/{telegramBotId}/variables/{id}/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getStats<ThrowOnError extends boolean = false>(
    options?: Options<TelegramBotsGetStatsData, ThrowOnError>,
  ): RequestResult<
    TelegramBotsGetStatsResponses,
    TelegramBotsGetStatsErrors,
    ThrowOnError
  > {
    return (options?.client ?? client).get<
      TelegramBotsGetStatsResponses,
      TelegramBotsGetStatsErrors,
      ThrowOnError
    >({ url: '/api/telegram-bots/stats/', ...options });
  }
}

export class UsersService {
  public static postUserLogin<ThrowOnError extends boolean = false>(
    options: Options<UsersPostUserLoginData, ThrowOnError>,
  ): RequestResult<
    UsersPostUserLoginResponses,
    UsersPostUserLoginErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      UsersPostUserLoginResponses,
      UsersPostUserLoginErrors,
      ThrowOnError
    >({
      url: '/api/users/login/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static postUserLoginInit<ThrowOnError extends boolean = false>(
    options?: Options<UsersPostUserLoginInitData, ThrowOnError>,
  ): RequestResult<
    UsersPostUserLoginInitResponses,
    UsersPostUserLoginInitErrors,
    ThrowOnError
  > {
    return (options?.client ?? client).post<
      UsersPostUserLoginInitResponses,
      UsersPostUserLoginInitErrors,
      ThrowOnError
    >({ url: '/api/users/login-init/', ...options });
  }

  public static deleteUser<ThrowOnError extends boolean = false>(
    options?: Options<UsersDeleteUserData, ThrowOnError>,
  ): RequestResult<UsersDeleteUserResponses, UsersDeleteUserErrors, ThrowOnError> {
    return (options?.client ?? client).delete<
      UsersDeleteUserResponses,
      UsersDeleteUserErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/users/me/',
      ...options,
    });
  }

  public static getUser<ThrowOnError extends boolean = false>(
    options?: Options<UsersGetUserData, ThrowOnError>,
  ): RequestResult<UsersGetUserResponses, UsersGetUserErrors, ThrowOnError> {
    return (options?.client ?? client).get<
      UsersGetUserResponses,
      UsersGetUserErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/users/me/',
      ...options,
    });
  }

  public static postUserAcceptTerms<ThrowOnError extends boolean = false>(
    options?: Options<UsersPostUserAcceptTermsData, ThrowOnError>,
  ): RequestResult<
    UsersPostUserAcceptTermsResponses,
    UsersPostUserAcceptTermsErrors,
    ThrowOnError
  > {
    return (options?.client ?? client).post<
      UsersPostUserAcceptTermsResponses,
      UsersPostUserAcceptTermsErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/users/me/accept-terms/',
      ...options,
    });
  }

  public static postUserLogout<ThrowOnError extends boolean = false>(
    options?: Options<UsersPostUserLogoutData, ThrowOnError>,
  ): RequestResult<
    UsersPostUserLogoutResponses,
    UsersPostUserLogoutErrors,
    ThrowOnError
  > {
    return (options?.client ?? client).post<
      UsersPostUserLogoutResponses,
      UsersPostUserLogoutErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/users/me/logout/',
      ...options,
    });
  }

  public static postUserLogoutAll<ThrowOnError extends boolean = false>(
    options?: Options<UsersPostUserLogoutAllData, ThrowOnError>,
  ): RequestResult<
    UsersPostUserLogoutAllResponses,
    UsersPostUserLogoutAllErrors,
    ThrowOnError
  > {
    return (options?.client ?? client).post<
      UsersPostUserLogoutAllResponses,
      UsersPostUserLogoutAllErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/users/me/logout-all/',
      ...options,
    });
  }

  public static postUserTokenRefresh<ThrowOnError extends boolean = false>(
    options: Options<UsersPostUserTokenRefreshData, ThrowOnError>,
  ): RequestResult<
    UsersPostUserTokenRefreshResponses,
    UsersPostUserTokenRefreshErrors,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      UsersPostUserTokenRefreshResponses,
      UsersPostUserTokenRefreshErrors,
      ThrowOnError
    >({
      url: '/api/users/me/token-refresh/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getStats<ThrowOnError extends boolean = false>(
    options?: Options<UsersGetStatsData, ThrowOnError>,
  ): RequestResult<UsersGetStatsResponses, UsersGetStatsErrors, ThrowOnError> {
    return (options?.client ?? client).get<
      UsersGetStatsResponses,
      UsersGetStatsErrors,
      ThrowOnError
    >({ url: '/api/users/stats/', ...options });
  }

  public static getTokenList<ThrowOnError extends boolean = false>(
    options?: Options<UsersGetTokenListData, ThrowOnError>,
  ): RequestResult<UsersGetTokenListResponses, UsersGetTokenListErrors, ThrowOnError> {
    return (options?.client ?? client).get<
      UsersGetTokenListResponses,
      UsersGetTokenListErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/users/tokens/',
      ...options,
    });
  }

  public static getToken<ThrowOnError extends boolean = false>(
    options: Options<UsersGetTokenData, ThrowOnError>,
  ): RequestResult<UsersGetTokenResponses, UsersGetTokenErrors, ThrowOnError> {
    return (options.client ?? client).get<
      UsersGetTokenResponses,
      UsersGetTokenErrors,
      ThrowOnError
    >({
      security: [{ name: 'Authorization', type: 'apiKey' }],
      url: '/api/users/tokens/{jti}/',
      ...options,
    });
  }
}
